export default "__VITE_ASSET__D5BVWWmL__"